<template>
    <div>
        <v-card class="rounded-lg" elevation="4">
            <v-tabs fixed-tabs background-color="#41916b" dark>
                <v-tabs-slider color="#086318"></v-tabs-slider>
                <v-tab>Órgãos Captados e Não aproveitados</v-tab>

                <v-tab-item>
                    <v-card-text>
                        <v-row dense><v-col class="d-flex" cols="12" sm="2">
                                <v-select 
                                :items="captations"
                                :disabled="this.$route.query.item"
                                color="#086318" 
                                v-model="distributionForm.donor_id"
                                @change="searchOrgon(), getOrgonsTable()"
                                class="rounded-lg"
                                item-value="id"
                                item-text="name"  
                                dense 
                                outlined 
                                label="Doador">
                                </v-select>
                            </v-col><v-col class="d-flex" cols="12" sm="2">
                                <v-select 
                                :items="orgons"
                                color="#086318" 
                                v-model="distributionForm.orgon_id"
                                class="rounded-lg"
                                item-value="orgon_id"
                                item-text="orgon.name"  
                                dense 
                                outlined 
                                @change="realizedDialog = true"
                                label="Orgãos Captados">
                                </v-select>
                            </v-col>
                            <v-col class="d-flex" cols="12" sm="5" v-if="transplantNotPerfomed">
                                <v-select 
                                :items="reasons_list"
                                color="#086318" 
                                v-model="distributionForm.reason_id"
                                class="rounded-lg"
                                item-value="id"
                                item-text="description"  
                                dense 
                                outlined 
                                label="Motivos do descarte">
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="2" v-if="distributionForm.reason_id == 9">
                                <v-text-field
                                    label="Outros"
                                    variant="outlined"
                                    class="rounded-lg"
                                    placeholder="Descreva aqui"
                                    color="#d21631"
                                    v-model="distributionForm.otherReason"
                                    dense 
                                    outlined 
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12"  md="1" v-if="transplantNotPerfomed">
                                <v-btn elevation="1" fab small color="#41916b" @click="saveRefused()">
                                    <span class="textBtn" color
                                    style="color:white"><v-icon>mdi-plus</v-icon></span>
                                </v-btn> 
                            </v-col>
                        </v-row>
                            <v-data-table
                                :headers="headers"
                                :items="tableItems"
                                :footer-props="{'items-per-page-text': 'Doador por Página',}"
                                :page="page"
                                :loading="loading">

                                <template v-slot:[`item.value`]="{ item }">
                                <TagTipoCaptacao :resource="item"/>
                                </template>
                        
                                <template v-slot:[`item.actions`]="{ item }">
                                <v-tooltip left color="#41916b">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            size="22"
                                            class="icon"
                                            color="#41916b" 
                                            v-on="on"
                                            v-bind="attrs"
                                            align-item="center"
                                            @click="redirect(item)">mdi-eye
                                        </v-icon>
                                    </template>
                                    <span style="color:white">{{$t('buttons.edit')}}</span>
                                </v-tooltip>
                                <v-tooltip right color="#474545">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            size="22"
                                            class="icon"
                                            color="#474545" 
                                            v-on="on"
                                            v-bind="attrs"
                                            align-item="center"
                                            @click="$router.push({path: '/relatorio-captacao', query:{item:item}})">mdi-call-made
                                        </v-icon>
                                    </template>
                                    <span style="color:white">Imprimir Relatório</span>
                                </v-tooltip>
                                </template>
                                
                            </v-data-table>
                    </v-card-text>
                </v-tab-item>
            </v-tabs>
        </v-card>

        <v-dialog v-model="realizedDialog" width="380px" persistent>
            <v-card>
                <v-card-title>
                    <v-icon style="padding: 5px; color: #41916b;">mdi-comment-question</v-icon>
                    <span class="text-h5">Transplante Realizado?</span>
                </v-card-title>
                <br>
                <v-card-actions>
                    
                    <v-spacer></v-spacer>
            
                    <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="realizedDialog = false, transplantNotPerfomed = true"
                    >
                    Não
                    </v-btn>
                    <v-btn
                    style="background-color:#41916b; color: white;"
                    variant="text"
                    @click="realizedOrAvailable = true, realizedDialog = false"
                    >
                    Sim
                    </v-btn>
                </v-card-actions>
                </v-card>
        </v-dialog>

        <v-dialog v-model="realizedOrAvailable" width="650px" persistent>
            <v-card>
                <v-card-title>
                    <v-icon style="padding: 5px; color: #41916b;">mdi-comment-question</v-icon>
                    <span class="text-h5">Transplante realizado na Bahia ou Disponibilizado?</span>
                </v-card-title>
                <br>
                <v-card-actions>
                    
                    <v-spacer></v-spacer>
            
                    <v-btn
                    style="background-color:#075214; color: white;"
                    variant="text"
                    @click="transplantBahia = true, realizedOrAvailable = false"
                    >
                    Realizado na Bahia
                    </v-btn>
                    <v-btn
                    style="background-color:#41916b; color: white;"
                    variant="text"
                    @click="disponibilized = true, realizedOrAvailable = false"
                    >
                    Disponibilizado
                    </v-btn>
                </v-card-actions>
                </v-card>
        </v-dialog>

        <v-dialog v-model="transplantBahia" width="400px" persistent>
            <v-card>
                <v-card-title>
                    <v-icon style="padding: 5px; color: #41916b;">mdi-comment-question</v-icon>
                    <span class="text-h5">Transplante na Bahia</span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="12">
                                <h4>Confirmamos então que houve a realização de um transplante para o paciente informado abaixo:</h4>
                            </v-col>
                            <v-col cols="12" sm="6" md="12">
                                <v-text-field
                                    label="Informe o RGCT do Receptor:"
                                    variant="outlined"
                                    :rules="formRules" 
                                    color="#d21631"
                                    v-model="distributionForm.rgct_receiver"
                                    maxlength="11" 
                                    v-mask="'#######-###'"
                                    placeholder="999999-999"
                                    dense 
                                    outlined 
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
            
                    <v-btn
                        color="blue-darken-1"
                        variant="text"
                        @click="transplantBahia = false"
                        >
                    {{$t('buttons.cancel')}}
                    </v-btn>
                    <v-btn
                    style="background-color:#41916b; color: white;"
                    variant="text"
                    @click="sendReceptorRgct()"
                    >
                    Enviar
                    </v-btn>
                </v-card-actions>
                </v-card>
        </v-dialog>

        <v-dialog v-model="disponibilized" width="600px" persistent>
            <v-card>
                <v-card-title>
                    <v-icon style="padding: 5px; color: #41916b;">mdi-comment-question</v-icon>
                    <span class="text-h5">Disponibilização</span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="12">
                                <h4>Para disponibilização preencha os campos abaixo:</h4>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                    label="RGCT do Receptor:"
                                    variant="outlined"
                                    :rules="formRules" 
                                    color="#d21631"
                                    maxlength="10"
                                    v-mask="'######-###'"
                                    v-model="distributionForm.rgct_receiver"
                                    dense 
                                    outlined 
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-autocomplete
                                    color="#086318" 
                                    placeholder="uf" 
                                    v-model="distributionForm.state"
                                    :items="state"
                                    item-text="name" 
                                    item-value="name" 
                                    dense 
                                    outlined 
                                    label="Estado">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="12">
                                <v-textarea
                                    label="Informe o Motivo da Disponibilização:"
                                    auto-grow
                                    variant="outlined"
                                    :rules="formRules" 
                                    rows="3"
                                    color="#d21631"
                                    row-height="25"
                                    v-model="distributionForm.description_reason_other"
                                    dense 
                                    outlined 
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
            
                    <v-btn
                        color="blue-darken-1"
                        variant="text"
                        @click="disponibilized = false"
                        >
                    {{$t('buttons.cancel')}}
                    </v-btn>
                    <v-btn
                    style="background-color:#41916b; color: white;"
                    variant="text"
                    @click="sendDisponibilized()"
                    >
                    Enviar
                    </v-btn>
                </v-card-actions>
                </v-card>
        </v-dialog>

        <v-snackbar absolute background-color="snackbarColor" :color="snackbarColor" v-model="snackbar">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                Fechar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import axios from "@/axios";

export default {
    data() {
        return {
            tab:4,
            dialog: false,
            displayError: {
                display: false,
                message: [],
            },
            orgonsCapted: [],
            orgonsArray: [],
            teste:[
                {
                    id: '1',
                    text: 'motivo 1'
                }, 
                {
                    id: '2',
                    text: 'motivo 2'
                }, 
                {
                    id: '3',
                    text: 'Outros'
                }, 
            ],
            headers: [
                {
                    text: "ORGÃO",
                    align: "center",
                    value: "orgon.name",
                },

                {
                    text: "STATUS",
                    align: "center",
                    value: "availabillity_status.description",
                },  
                {
                    text: "MOTIVO DO DESCARTE",
                    align: "center",
                    value: "reason.description",
                }, 
            ],
            distributionForm:{},
            pcrDonorDataForm:{},
            bloodSampleCollectionForm:{
                pephriferal:'',
                subclavian:'',
                femoral:'',
                intracardiac:'',
                others:'',
                sample_centrifugation:'',
            },
            obj:{
                blood_sample_collection: []
            },
            dialogDonor:false,
            realizedDialog: true,
            realizedOrAvailable: false,
            transplantBahia: false,
            disponibilized: false,
            transplantNotPerfomed: false,
            receptorRGCT: "",
            donor_id: "",
            loading: false,
            options: {},
            donor:[],
            state:[],
            data:[],
            arquivos: [],
            status_serology: [],
            captations: [],
            openButtons: false,
            selected:"",
            message: "",
            snackbar: false,
            snackbar_error: false,
            messageError: "",
            unity: "",
            donorName: "",
            is_donorName: "",
            is_donorSex: "",
            openModal: false,
            donorButton: true,
            isCreate: true,
            formRules: [
                (v) => !!v || "Este campo é obrigatório",
            ],
            orgons: [],
            tableItems: [],
            reasons_list: [],
        };
    },

    mounted(){
        this.getOrgons()
    },

    components:{},

    props:{},

    async created() { 
        let id = "";
        
        const stateResponse = await axios.get("/state");
        this.state = stateResponse.data.data;

        const donorResponse = await axios.get("/donor/allCaptations", { params: { id } });
        this.captations = donorResponse.data.data;

        const reasonsResponse = await axios.get("/reasons/list_reasons");
        this.reasons_list = reasonsResponse.data;

        if (this.$route.query.item) {
            this.distributionForm.donor_id = Number(this.$route.query.item.id || this.$route.query.item); // Converte para número se necessário
            this.searchOrgon();
            this.getOrgonsTable();
        }
    },

    watch: {
        "$route.query.item": {
            handler(newValue) {
                if (newValue) {
                    this.distributionForm.donor_id = Number(newValue.id || newValue);
                    this.searchOrgon();
                    this.getOrgonsTable();
                }
            },
            immediate: true
        },
        captations: {
            handler() {
                if (this.$route.query.item) {
                    this.distributionForm.donor_id = Number(this.$route.query.item.id || this.$route.query.item);
                    this.searchOrgon();
                    this.getOrgonsTable();
                }
            },
            immediate: true
        }
    },

    methods: {
        getOrgons(){
            if(this.$route.query.item.orgons_captured.length == 0){
                this.orgonsArray = []
                    let leftEye = new Object
                        leftEye.id = 6
                        leftEye.name = 'Córnea Esquerda'
                this.orgonsArray.push(leftEye) 
                    let rightEye = new Object
                            rightEye.id = 7
                            rightEye.name = 'Córnea Direita'
                this.orgonsArray.push(rightEye) 
            }else{
                axios.get(`/orgons_captured/${this.$route.query.item.id}`).then((response) => {
                    this.orgonsCapted = response.data.data;

                    for(let i = 0; i < this.orgonsCapted.length; i++){
                
                        let orgons = new Object
                            orgons.id = this.orgonsCapted[i].orgon_id
                            orgons.name = this.orgonsCapted[i].orgon_name

                        this.orgonsArray.push(orgons)
                    }
                });
            }
        },

        getOrgonsTable(){
            this.loading = true
            this.tableItems = []
            let donor_id = this.distributionForm.donor_id ? this.distributionForm.donor_id : this.$route.query.item.id
            axios.get(`/availability/byDonor/${donor_id}`).then((response) => {
                this.tableItems = response.data
                this.loading = false
            })
        },

        searchOrgon(){
            this.orgons = this.captations.filter((item) => item.id == this.distributionForm.donor_id)
            this.orgons = this.orgons[0].orgons_captured

        },

        sendReceptorRgct() {
            let obj = { ...this.distributionForm };
            obj.donor_id = this.distributionForm.donor_id ? this.distributionForm.donor_id : this.$route.query.item.id;
            obj.state_id = 1;
            obj.availabillity_status_id = 2;
            obj.reason_id = null;
            obj.description_reason_other = null;

            axios.post(`/availability/create`, obj)
                .then((response) => {
                    this.snackbar = true;
                    this.message = response.data.message;
                    this.snackbarColor = 'green';
                    this.transplantBahia = false;
                    this.distributionForm.orgon_id = "";
                    this.distributionForm.otherReason = "";
                    this.distributionForm.reason_id = "";
                    this.transplantNotPerfomed = false;
                    this.getOrgonsTable();
                })
                .catch((error) => {
                    let msg = "";

                    if (error.details && typeof error.details === "object") {
                        msg = Object.values(error.details)
                            .flat()  
                            .join("\n");  
                    } 
                    this.snackbar = true;
                    this.message = msg;
                    this.snackbarColor = 'red';
                }); 
        },

        sendDisponibilized() {
            let obj = { ...this.distributionForm };
            obj.donor_id = this.distributionForm.donor_id ? this.distributionForm.donor_id : this.$route.query.item.id;
            obj.availabillity_status_id = 1;

            axios.post(`/availability/create`, obj)
                .then((response) => {
                    this.snackbar = true;
                    this.message = response.data.message;
                    this.snackbarColor = 'green';
                    this.disponibilized = false;
                    this.distributionForm.orgon_id = "";
                    this.distributionForm.otherReason = "";
                    this.distributionForm.reason_id = "";
                    this.transplantNotPerfomed = false;
                    this.getOrgonsTable();
                })
                .catch((error) => {
                    this.snackbar = true;
                    this.message = error.details || "Erro ao processar a requisição.";
                    this.snackbarColor = 'red';
                });
        },

        saveRefused() {
            let obj = {
                orgon_id: parseInt(this.distributionForm.orgon_id),
                donor_id: this.distributionForm.donor_id ? this.distributionForm.donor_id : this.$route.query.item.id,
                reason_id: this.distributionForm.reason_id,
                description_reason_other: this.distributionForm.otherReason,
                availabillity_status_id: 3
            };

            axios.post(`/availability/create`, obj)
                .then((response) => {
                    this.snackbar = true;
                    this.message = response.data.message;
                    this.snackbarColor = 'green';
                    this.disponibilized = false;
                    this.distributionForm.orgon_id = "";
                    this.distributionForm.otherReason = "";
                    this.distributionForm.reason_id = "";
                    this.transplantNotPerfomed = false;
                    this.getOrgonsTable();
                })
                .catch((error) => {
                    const errorMessage = error.response?.data?.details || error.response?.data?.error || "Erro ao processar a requisição.";

                    this.snackbar = true;
                    this.message = errorMessage;
                    this.snackbarColor = 'red';
                });

        }
    }

};
</script>